<template>
  <div id="presence" class="presence">
    <page-header title="Журнал посещений" />
  
    <div class="presence__control-block">
      <el-badge
        class="presence__control-block__event"
        :value="`+${countNewSchedule}`"
        :hidden="!countNewSchedule"
      >
        <el-select
          v-model="currentEvent"
          :disabled="!currentEvent"
          filterable
          placeholder="Выберите событие"
        >
          <el-option
            v-for="(event, idx) in formatedSchedule"
            :key="idx"
            :label="event.fullName"
            :value="event.sid"
          >
          </el-option>
        </el-select>
      </el-badge>

      <el-select
        class="presence__control-block__month"
        v-model="selectedMonth"
        :disabled="!selectedMonth || !isInit || isLoad"
        placeholder="Месяц"
      >
        <el-option
          v-for="month in months"
          :key="`selected-year-${month.value}`"
          :label="month.name"
          :value="month.value"
        >
        </el-option>
      </el-select>

      <el-select
        class="presence__control-block__year"
        v-model="selectedYear"
        :disabled="!selectedYear || !isInit || isLoad"
        placeholder="год"
      >
        <el-option
          v-for="year in years"
          :key="`selected-year-${year.value}`"
          :label="year.name"
          :value="year.value"
        >
        </el-option>
      </el-select>

      <el-button
        v-if="filterButtonIsShow"
        class="presence__control-block__filter"
        @click="updateShedule"
      >
        Отфильтровать
      </el-button>
  
      <el-tooltip 
        :disabled="!recordBtnIsShow" 
        effect="light" 
        content="Необходимо сохранить изменения" 
        placement="top"
      >
        <div class="presence__control-block__bottom">
          <el-select
            v-model="currentGroupId"
            placeholder="Выберите группу"
            :disabled="recordBtnIsShow || !isInit || isLoad"
          >
            <el-option
              v-for="(group, idx) in groups"
              :key="idx"
              :label="group.groupName"
              :value="group.groupId"
            >
            </el-option>
          </el-select>

          <i class="fas fa-link"></i>

          <el-select
            v-model="currentTab"
            :disabled="recordBtnIsShow || !isInit || isLoad"
            placeholder="Выберите информацию"
          >
            <el-option
              v-for="item in typesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
              <el-tooltip
                :disabled="!item.disabled"
                effect="light"
                content="Что бы попасть в этот раздел, необходимо выбрать группу"
                placement="bottom"
              >
                <div class="presence__type-option">
                  <span>{{ item.label }}</span>
                  <i v-if="item.disabled" class="el-icon-lock"></i>
                </div>
              </el-tooltip>
            </el-option>
          </el-select>

          <VButton 
            class="presence__add-home-work"
            :disabled="!isInit || isLoad"
            @click="openModal"
          >
            Домашнее задание
          </VButton>
        </div>
      </el-tooltip>

      <transition name="fade">
        <VButton
          v-if="recordBtnIsShow"
          class="presence__control-block__save"
          type="success"
          pulse
          @click="saveData"
        >
          Записать
        </VButton>
      </transition>
    </div>

    <component
      class="presence__dinamic-component"
      :is="currentTab"
      :students="filtredStudents"
      :group-id="currentGroupId"
      :results="resultList"
      @update-student="updateStudent"
    />
  </div>
</template>

<script>
  // Components 
  import pageHeader from "../components/pageHeader";
  import VButton from "@/components/ui/VButton.vue";
  import disciplinesList from "../components/Presence/disciplinesList";
  import statement from "../components/Presence/statement";
  import studenstList from "../components/Presence/studenstList";
  import topicsCovered from "../components/Presence/topicsCovered"
  import homeWorkList from "../components/Presence/homeWorkList";

  import { mapActions, mapMutations, mapState } from 'vuex';
  export default {
    components: {
      disciplinesList,
      topicsCovered,
      homeWorkList,
      studenstList,
      pageHeader,
      statement,
      VButton
    },
  
    data() {
      return {
        countNewSchedule: 0,
        homeWork: null,
        groups: [],
        students: [],
        initialStudents: [],
        resultList: [],
        lesson: {},
        currentGroupId: null,
        currentTab: 'studenstList',
        schedule: [],
        currentEvent: null,
        selectedMonth: null,
        monthHasChanged: false,
        yearHasChanged: false,
        selectedYear: null,
        isLoad: false,
        isInit: false,
      }
    },

    computed: {
      ...mapState({
        months: state => state.handbook.months,
      }),

      filterButtonIsShow() {
        return this.monthHasChanged || this.yearHasChanged;
      },

      formatedSchedule() {
        return this.schedule.map(el => ({...el, fullName: `${this.$moment(el.date).format('DD.MM.YYYY')} | ${el.time_begin} | ${el.discipline} | ${el.type_workload}` }));
      },

      recordBtnIsShow() {
        return JSON.stringify(this.students) !== JSON.stringify(this.initialStudents);
      },

      typesOptions() {
        return [
          {
            value: "statement",
            label: "Посещаемость",
            disabled: !Boolean(this.currentGroupId),
          },
          {
            value: "topicsCovered",
            label: "Пройденные темы",
            disabled: !Boolean(this.currentGroupId),
          },
          {
            value: "disciplinesList",
            label: "Список дисциплин",
            disabled: !Boolean(this.currentGroupId),
          },
          {
            value: "studenstList",
            label: "Спиcок учащихся",
            disabled: false,
          },
          {
            value: "homeWorkList",
            label: "Домашние работы",
            disabled: !Boolean(this.currentGroupId),
          },
        ]
      },

      filtredStudents() {
        return this.currentGroupId ? this.students.filter(student => student.groupId === this.currentGroupId) : this.students;
      },

      years() {
        return Array.from(new Array(100)).map((_, idx) => {
          const year = new Date().getFullYear() - idx;

          return {
            value: year,
            label: String(year)
          };
        });
      }
    },

    watch: {
      async currentEvent(newValue) {
        if (this.isInit) {
          await this.$router.replace({ name: 'presence', params: { sid: newValue } });
          await this.getPageData();
          this.clearScheduleByMonth();
        }
      },

      async selectedYear() {
        if (this.isInit) {
          this.yearHasChanged = true;
        }
      },

      async selectedMonth() {
        if (this.isInit) {
          this.monthHasChanged = true; 
        }
      } 
    },
  
    async created() {
      await this.init();
    },

    methods: {
      ...mapActions(["fetchDataForPage", "updateDataPage"]),
      ...mapMutations(["setModalData"]),

      clearScheduleByMonth() {
        this.schedule = this.schedule.filter(el => this.$moment(el.date, 'YYYY-MM-DD').month() + 1 === +this.selectedMonth);
      },

      async updateShedule() {
        if (this.isInit) {
          const day = this.$moment(this.lesson.dateTime, 'DD.MM.YYYY').date();
          const date = `${day}.${this.selectedMonth}.${this.selectedYear}`;
          const schedule = await this.getSchedule(date);
          const currentEvent = this.schedule.find(el => el.sid === this.currentEvent);
          this.countNewSchedule = schedule.length;
          const timeoutId = setTimeout(() => {
            this.countNewSchedule = 0;
            clearTimeout(timeoutId);
          }, 4000);
          this.schedule = [currentEvent, ...schedule];
          this.monthHasChanged = false;
          this.yearHasChanged = false;
        }
      },

      async init() {
        await this.getPageData();
        const schedule = await this.getSchedule(this.lesson.dateTime);
        this.schedule = schedule;
        this.currentEvent = +this.$route.params.sid;
        const date = this.$moment(this.lesson.dateTime, 'DD.MM.YYYY');
        const month = date.month();
        this.selectedMonth = `${month < 10 ? '0' : ''}${month + 1}`;
        this.selectedYear = date.year();

        await this.$nextTick();

        this.isInit = true;
      },

      async getSchedule(date) {
        try {
          this.isLoad = true;
          const { data: { schedule } } = await this.axios.get("/api/journal", { params: { date_filter: date } });
        
          if (schedule) {
            return schedule ? schedule : [];
          }
        } catch (e) {
          console.warn('Failed fetch [presence/getSchedule]', e);
        } finally {
          this.isLoad = false;
        }
      },

      async getPageData() {
        this.isLoad = true;
        const { data, status } = await this.fetchDataForPage(this.$route.path);
        if (status === 200) {
          this.reformatPageData(data);
        }
        this.isLoad = false;
        this.currentTab = 'studenstList';
        this.currentGroupId = null;
      },

      reformatPageData(data) {
        const { groups, students } = data.students.reduce((acc, { groupId, groupName,  students }) => {
          acc.groups.push({ groupId, groupName});
          acc.students = [...acc.students, ...students.map(student => ({...student,  groupId, absence: +student.absence }))];
          return acc;
        }, { groups: [], students: []});

        this.groups = groups;
        this.students = students;
        this.lesson = data.lesson;
        this.resultList = [ { id: null, name: '' }, ...data.resultList];
        this.initialStudents = JSON.parse(JSON.stringify(students));
        this.homeWork = data.home_work;
      },

      updateStudent({ field, id, value }) {
        const studentIndex = this.students.findIndex(student => student.id === id);
        this.students[studentIndex][field] = value;
      },

      async openModal() {
        let obj = {
          name: "HomeWorkModal",
          data: { ...this.homeWork, cb: this.getPageData },
          title: 'Домашнее задание',
        };

        this.setModalData(obj);
      },

      async saveData() {
        try {
          this.isLoad = true;
          const { status } = await this.axios.patch(`api/journal/presence/${this.$route.params.sid}`, this.students);

          this.notify(status, status ? 'Записи успешно изменены' : 'При записи возникла ошибка, попробуйте позже');

          await this.getPageData();          
        } catch (e) {
          console.warn('Fetch error [studenstList/saveData]', e);
        } finally {
          this.isLoad = false;
        }
      },

      notify(status, text) {
        const h = this.$createElement;
        this.$notify({
          title: "",
          message: h(
            "i",
            { style: `color: ${status ? "#67C23A" : " #f56c6c"}` },
            text
          ),
        });
      },
    }
  }
</script>

<style lang="scss">
  .presence {
    box-sizing: border-box;
    width: 100%;
    max-width: 1024px;
    height: 100%;
    display: grid;
    row-gap: 10px;
    grid-template-rows: auto auto 1fr;

    .el-row {
      margin-bottom: 20px;
    }

    &__dinamic-component {
      height: 100%;
      overflow: auto;
    }

    .presence__control-block {
      display: grid;
      gap: 20px;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 102px;
      grid-template-areas: 'event event month year filter .' 'bottom bottom bottom bottom . save';
      margin-bottom: 20px;

      &__event {
        grid-area: event;

        .el-select {
          width: 100%;
        }
      }

      &__month {
        grid-area: month;
      }

      &__year {
        grid-area: year;
      }

      &__save {
        grid-area: save;
      }

      &__filter {
        grid-area: filter;
      }

      &__bottom {
        grid-area: bottom;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
    }

    .presence__add-home-work {
      margin-left: 20px;
    }

    .fa-link {
      color: $regular-text-clr;
      padding: 0 10px;
    }
  }

  .presence__type-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 500px) {
    .presence {
      .presence__control-block {
        justify-content: center;
        .el-select,
        .fa-link {
          text-align: center;
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
  }
</style>